export default __webpack_public_path__ + "static/media/hour_glass.63985300.gif";